/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientImage/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import ButtonIconLabel from 'DesignSystem/ButtonIconLabel/index'
import React from 'react'
import XrayIcon from 'DesignSystem/Svgs/XrayIcon/index'



/** @type {import('Simple/types.js').View} */
export default function PatientImage({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/SystemFiles/FilesTree/ImageSeries/Body/Content/Images/Content/PatientImage"
  
}) {
let patientImageSlotKeyValueData = fromData.useDataFormat({ viewPath,
context: 'patient_image',
path: 'slot_key',
format: fromHelpers.name,
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ButtonIconLabel
  viewPath={`${viewPath}/ButtonIconLabel`}
 marginTop={4}
 data="patient_image.slot_key"
 format="./helpers.js name"
 text={patientImageSlotKeyValueData}
 onClick={onClick}
>
{childProps => (
<XrayIcon
{...childProps}
  viewPath={`${viewPath}/XrayIcon`}
 width={16}
 height={16}
 stroke="rgba(0,0,0,0.7)"
/>
)}
</ButtonIconLabel>
{children}
</React.Fragment>)
}